import { sanitizeTerminalDisplayText } from "../ui/terminal-safe-text";

const WAKELOOP_SYSTEM_PROFILE_ID = "wakeloop-system";
const WAKELOOP_SYSTEM_PROFILE_NAME = "wakeloop system";

type WakeLoopSystemProfileIdentityLike =
  | {
      kind?: unknown;
      wakeLoopProfileId?: unknown;
      profileId?: unknown;
      profileName?: unknown;
    }
  | null
  | undefined;

const normalizeProfileValue = (value: unknown): string =>
  sanitizeTerminalDisplayText(
    typeof value === "string" || typeof value === "number" ? value : "",
    "single-line"
  )
    .trim()
    .toLowerCase();

export function isWakeLoopSystemProfileIdentity(
  profileIdentity: WakeLoopSystemProfileIdentityLike
): boolean {
  if (!profileIdentity || typeof profileIdentity !== "object") {
    return false;
  }

  const kind = normalizeProfileValue(profileIdentity.kind);
  if (kind === "system") {
    return true;
  }

  const profileId = normalizeProfileValue(
    profileIdentity.wakeLoopProfileId ?? profileIdentity.profileId
  );
  if (profileId === WAKELOOP_SYSTEM_PROFILE_ID) {
    return true;
  }

  const profileName = normalizeProfileValue(profileIdentity.profileName);
  return profileName === WAKELOOP_SYSTEM_PROFILE_NAME;
}
